import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var FullPaddedWrapper = styled.div.withConfig({
  displayName: "NoResults__FullPaddedWrapper",
  componentId: "ng4242-0"
})(["padding:", "px;"], spacing.base);

var NoResults = function NoResults(_ref) {
  var term = _ref.term;
  return React.createElement(FullPaddedWrapper, null, React.createElement("span", null, "We couldn't find anything matching ", React.createElement("strong", null, term)));
};

export default NoResults;